import { act } from "react";
import { getOrCreateDeviceId, checkNotificationStatus } from "./utils";
import { fcmManager } from "./fcmManager"; // Assicurati di avere un modulo per gestire FCM

const API_PREFIX = process.env.REACT_APP_API_URL;

// helper per recuperare il token di sessione
const getToken = () => JSON.parse(localStorage.getItem('authData'))?.token;


/**
 * Login utente.
 * @param {{email:string,password:string}} credentials
 * @returns {Promise<{code:number,data:any,error_messages:string[]}>}
 */
export async function loginUser({ email, password }) {
    
    const deviceId = getOrCreateDeviceId();//recupera o crea un device_id univoco
    const notification_active = fcmManager.isNotificationAvailable();
    let fcmtoken = null;
    if(notification_active){
        fcmtoken = await fcmManager.refreshToken(true);
        console.log("FCM Token:", fcmtoken);
    }

    const res = await fetch(
        `${API_PREFIX}/pub/pwa/login`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                email,
                password,
                device_id: deviceId,
                device_browser: window.navigator.userAgent,
                device_os: window.navigator.platform,//recupera il sistema operativo se disponibile
                notification_active,
                fcmtoken
            })
        }
    );
    const response = await res.json();

    console.log("Login response:", response);
    
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }

    // Dopo login riuscito, mostra prompt notifiche se non attive
    setTimeout(() => {
        if (!fcmManager.isNotificationAvailable()) {
            fcmManager.showNotificationPrompt();
        }
    }, 1000);

    return response;
}

// API per aggiornare token FCM
export const updateFcmToken = async (fcmtoken) => {
    const token = getToken();
    const device_id = getOrCreateDeviceId();//recupera o crea un device_id univoco
    const notification_active = fcmManager.isNotificationAvailable();

    const res = await fetch(
        `${API_PREFIX}/custom/pwa/refreshfcmtoken`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ 
                fcmtoken, 
                device_id,
                notification_active
            })
        }
    );
    if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
};

//funzione generica per recuperare liste di dati da API
export const getItems = async (action, params = {}) => {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa${action}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}
//funzione generica per ottenere il modello e i campi del form
export async function getContent(action) {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa${action}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}
//funziona generica per salvare i contenuti
export async function saveContent(action, model){
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa${action}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(model)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

/**
 * Imposta lo stato utente.
 * @param {number} value - Nuovo stato di disponibilità (1, 2 o 3).
 * @param {string} token - Token di autenticazione.
 * @returns {Promise<{code:number,data:any,error_messages:string[]}>}
 */
export async function setUserStatus(value) {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/impostadisponibilita`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ disponibilita: value })
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];

}

//recupera lo stato utente
export const getUserStatus = async () => {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/disponibilitautente`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data']['id'] || 1;
};

// Imposta lo stato di lettura di una chiamata
export async function setCallRead(callId, isRead) {
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        id: callId,
        read: isRead ? 1 : 0
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/setpwaparams`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

// Imposta il tag su una chiamata
export async function setCallTag(callId, tag) {
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        id: callId,
        tag: tag
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/setpwaparams`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

export async function forwardCall(callId) {
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        call: callId,
        operation: 'call_forward_customer'
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/rispondichiamata`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

export async function chiamaEInoltra(contact){
    // Recupera token da localStorage
    const token = getToken();
    //qui in futuro potrei passara direttamente un numero di telefono numtel
    //il contact sarebbe facoltativo ma per ora sviluppiamo così.
    //passare il numtel servirebbe per inviare un contatto direttamente
    //dalla rubrica del telefono
    const params = {
        contact
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/chiamacontatto`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

export async function sendCallInstructions(callId, note) {
    console.log("Invio istruzioni per la chiamata:", callId, note);
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        call: callId,
        operation: 'send_instruction',
        message: note
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/rispondichiamata`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

export async function sendMessage(message) {
    console.log("Invio messaggio:", message);
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        message
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/inviamessaggio`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

// Imposta il blocco per un contatto
export async function setContactBlock(id, blockType, type = 'call') {
    // Recupera token da localStorage
    const token = getToken();
    let params = {
        type: blockType
    };
    params[type] = id; // Aggiungi il tipo di blocco
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/bloccachiamata`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    return res.json();
}

// Imposta la priorità di una chiamata
export async function setContactPriority(callId, blockType) {
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        call: callId,
        type: blockType
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/prioritachiamata`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    return res.json();
}

//Cancella una faq
export const deleteFaq = async (id) => {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/deletefaq/id/${id}`,
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}
//cancella 1 o + contatti
export async function deleteContatti(ids) {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/deletecontatti`,
        {
            method: 'POST',
            body: JSON.stringify({ ids }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}
//cancella un referente
export async function deleteReferente(id) {
    // Recupera token da localStorage
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/deletereferente/id/${id}`,
        {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
}

// Lista mensilità disponibili
export const getListaMensilita = async () => {
  const token = getToken();
  const res = await fetch(
      `${API_PREFIX}/custom/pwa/listamensilitastato`,
      {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
          }
      }
  );
  if (!res.ok) {    // Controlla prima lo stato HTTP
      throw new Error(`HTTP error! status: ${res.status}`);
  }
  const response = await res.json();
  if (response.code !== 200) {
      throw new Error(response.error_messages.join('\n'));
  }
  return response['data'];
};

// Pacchetti SMS disponibili
export const getPacchettiSms = async () => {
  //return await apiCall('/pacchettisms', 'GET');
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/pacchettisms`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];

};

// Stato servizio per un determinato mese
export const getStatoServizio = async (month) => {
  //return await apiCall('/stato', 'POST', { month });
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/statoservizio`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ month })
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
};

// Download fattura PDF
export const downloadFattura = async (id) => {
  //return await apiCall(`/fattura/id/${id}`, 'GET');
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/fattura/id/${id}`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
};

//funzione per chiedere al backend il link per il pagamento PayPal
export const iniziaPagamentoPaypal = async (idFattura = null, pacchetto = null) => {
    // Recupera token da localStorage
    const token = getToken();
    const params = {
        fattura: idFattura,
        pacchetto: pacchetto
    };
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/iniziapagamentopaypal`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(params)
        }
    );
    if (!res.ok) {    // Controlla prima lo stato HTTP
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];

}

// Recupera configurazione notifiche
export const getNotificationSettings = async () => {
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/notification`,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
    );
    if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
};

// Salva configurazione notifiche
export const updateNotificationSettings = async (settings) => {
    const token = getToken();
    const res = await fetch(
        `${API_PREFIX}/custom/pwa/editnotification`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(settings)
        }
    );
    if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
    }
    const response = await res.json();
    if (response.code !== 200) {
        throw new Error(response.error_messages.join('\n'));
    }
    return response['data'];
};